import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import HighlightMask from '@/components/HighlightMask/HighlightMask';
import { fieldTypes } from '@/helpers/constants';

type SeriesDropdownProps = {
  id: string;
  options: string[];
  value: string;
  handleChange: (event: React.SyntheticEvent, value: string | null) => void; // eslint-disable-line no-unused-vars
  checkEnabled: boolean;
  placeHolder: string;
  fieldPath: string[];
};

const SeriesDropdown: React.FC<SeriesDropdownProps> = (props) => {
  const { id, options = [], value, handleChange = () => {}, checkEnabled, placeHolder, fieldPath } = props;

  return (
    <Autocomplete
      disabled={checkEnabled}
      disableClearable={value === ''}
      id={`${id}-autocomplete`}
      options={options}
      getOptionLabel={(option) => option}
      filterSelectedOptions
      freeSolo
      onChange={handleChange}
      renderInput={(params) => (
        <HighlightMask
          fieldId={id}
          fieldPath={fieldPath}
          value={value}
          fieldType={fieldTypes.DROPDOWN}
          disabled={checkEnabled}
          isSeriesDropdown
        >
          <TextField {...params} variant="standard" placeholder={placeHolder} margin="none" />
        </HighlightMask>
      )}
      style={{ minWidth: 100 }}
      value={value}
    />
  );
};

export default SeriesDropdown;
